import { PAGE_GROUP_CHANGED } from '@web-platform/shared-universal-constants/src/pageGroups';

import type { PageGroup } from '@web-platform/shared-universal-constants/src/pageGroups';
import type { PageGroupChangedAction } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';

export const pageGroupChanged = (name: PageGroup): PageGroupChangedAction => ({
  type: PAGE_GROUP_CHANGED,
  payload: { name },
});
